/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'meter': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M473.53 360.23h-88.15v-51.89h9A27.44 27.44 0 00421.77 281v-68.87a27.44 27.44 0 00-27.36-27.36h-9v-40.6a78.57 78.57 0 00-78.6-78.57H102a78.57 78.57 0 00-78.57 78.57v204.77A78.57 78.57 0 00102 427.51h268.38a15 15 0 0015-15v-22.28h73.15v41.17a15 15 0 0030 0v-56.17a15 15 0 00-15-15zm-118.15-74.17v62.88a48.57 48.57 0 01-48.57 48.57H102a48.58 48.58 0 01-48.57-48.57V144.17A48.57 48.57 0 01102 95.6h204.81a48.56 48.56 0 0148.57 48.57v141.89z"/><path pid="1" d="M201.33 131.27a116.11 116.11 0 10116.11 116.1 116.24 116.24 0 00-116.11-116.1zm0 202.21a86.11 86.11 0 1186.11-86.11 86.21 86.21 0 01-86.11 86.11z"/><path pid="2" d="M201.33 177.22a70.15 70.15 0 1070.15 70.15 70.23 70.23 0 00-70.15-70.15zm0 110.3a40.15 40.15 0 1140.15-40.15 40.19 40.19 0 01-40.15 40.15z"/>'
  }
})
